// 節點資產概覽區塊 - 繁體中文
export default {
  asset: {
    totalValue: "資產總價值",
    totalExplain:
      "地址總資產餘額是根據本系統已收錄的幣種價值，按地址持有的所有主幣和代幣折算USDT的總餘額",
    supportedPrefix: "系統當前已支持",
    supportedLinkText: "317個幣種",
    tronNote: "Tron鏈幣種數據當前僅支持TRX、USDT",
    updateSuffix: " 更新",
  },
  balance: {
    mainBalanceSuffix: "餘額:",
    usdtBalance: "USDT餘額:",
    btcBalance: "BTC餘額",
    approxUSDT: "(≈{value}\u00A0USDT)",
    currentBalancePrefix: "當前餘額：",
    remark: "備註：",
  },
};
